import React from 'react';
import VidaSectionHeader from '../vida-section-header';

interface Props {
  title: string;
  id?: string;
}

const VidaSection: React.FC<Props> = ({ title, id, children }) => (
  <React.Fragment>
    <VidaSectionHeader id={id}>{title}</VidaSectionHeader>
    <div className="content">{children}</div>
  </React.Fragment>
);

export default VidaSection;
